import { render, staticRenderFns } from "./Lrecord.vue?vue&type=template&id=28947a86&scoped=true"
import script from "./Lrecord.vue?vue&type=script&lang=js"
export * from "./Lrecord.vue?vue&type=script&lang=js"
import style0 from "./Lrecord.vue?vue&type=style&index=0&id=28947a86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28947a86",
  null
  
)

export default component.exports